import React from "react";
import { useNavigate } from "react-router-dom";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import FormAddEditRole from "../../components/roles/FormAddEditRole";

const CreateRole = () => {
    const navigate = useNavigate();
    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditRole
                isEdit={false}
                currentData={null}
                onSubmitSuccess={() => navigate("/settings/roles")}
            />
        </WrapperSection>
    );
};

export default CreateRole;
